import './ResultPanel.css';
import type { JeffCall } from '../../../shared/types.ts';
import { DIRECTION_META } from '../../config/jeff.ts';

interface ResultPanelProps {
  call: JeffCall;
  /** One of the rotating broadcast headlines. */
  headline: string;
  /** An easter-egg line, when one fired. Cosmetic only. */
  egg?: string | null;
  onNewCall: () => void;
}

/**
 * The moment the whole product exists for.
 *
 * The direction is stated as a word, with a directional glyph beside it — never
 * as colour alone. A screen reader gets the verdict in one assertive
 * announcement, and a colour-blind viewer gets it from the text and the arrow.
 */
export function ResultPanel({
  call,
  headline,
  egg,
  onNewCall,
}: ResultPanelProps) {
  const meta = DIRECTION_META[call.direction];
  const arrow = call.direction === 'LONG' ? '▲' : '▼';

  return (
    <div className={`result result--${call.direction.toLowerCase()}`}>
      <div className="result__scrim" />

      <div className="result__body">
        <p className="result__headline">{headline}</p>

        {call.asset && <p className="result__asset">{call.asset}</p>}
        {call.price && <p className="result__price">{call.price}</p>}

        <p className="result__verdict" role="status" aria-live="assertive">
          <span className="result__arrow" aria-hidden="true">
            {arrow}
          </span>
          <span className="result__direction">{meta.label}</span>
        </p>

        <p className="result__spoken">{meta.verdict}</p>

        {call.context && <p className="result__context">&ldquo;{call.context}&rdquo;</p>}

        {egg && <p className="result__egg">{egg}</p>}

        <div className="result__actions">
          <button type="button" className="btn btn--primary" onClick={onNewCall}>
            New call
          </button>
        </div>
      </div>
    </div>
  );
}
